import { Component, Host, h, Prop, State, Watch } from "@stencil/core";
import { store, Unsubscribe /*Unsubscribe*/ } from "@stencil/redux";
import { CobrowseService, Log } from "../../services";
import { SketchService } from "../../services/sketch.service";
import { RootState } from "../../store/states";
import { Listen } from "@stencil/core";
import { ISketch } from "@auvious/sketch";
import { SketchToolEnum } from "../../models";
import { NotificationService } from "../../services/notification.service";
import { ErrorCode } from "../../models/enums";

interface ISketchState {
  id?: string;
}

const DEFAULT_SKETCH_STATE: ISketchState = {
  id: null,
};

// const STYLESHEET_ID = 'app-auvious-sketch-style'

@Component({
  tag: "app-sketch",
  styleUrl: "app-sketch.scss",
  shadow: true,
})
export class AppSketch {
  @Prop() room: string;

  @Prop({ mutable: true }) $sketchTool: SketchToolEnum;
  @Prop({ mutable: true }) $connectionId: string;

  @State() viewState: ISketchState = { ...DEFAULT_SKETCH_STATE };

  private sketch: ISketch;
  private storeUnsubscribe: Unsubscribe;

  @Watch("$sketchTool")
  toolChanged() {
    // caused controls to disappear.
    // if (!!this.$sketchTool) {
    //   const rules = `body>*:not(app-auvious-widget){
    //     filter: grayscale(0.8);
    //  }`;
    //   this.addCSSRule(rules);
    // } else {
    //   this.removeCSSRules();
    // }
  }

  @Watch("$connectionId")
  connectionChanged() {
    if (!this.$connectionId) {
      // this.removeCSSRules();
      // document.getElementById(STYLESHEET_ID)?.remove();
      SketchService.clear();
    }
  }

  @Listen("scroll", { target: "window" })
  handleScroll() {
    this.sketch.scrollTo(window.scrollY, window.scrollX);
  }

  @Listen("resize", { target: "window" })
  handleResize() {
    this.sketch?.resize(window.innerWidth, window.innerHeight);
  }

  connectedCallback() {
    if (this.storeUnsubscribe) this.storeUnsubscribe();

    this.storeUnsubscribe = store.mapStateToProps(
      this,
      (rootState: RootState) => {
        const {
          sketch: { activeTool, id },
        } = rootState;
        return { $sketchTool: activeTool, $connectionId: id };
      }
    );

    // create style placeholder. This will get updated on view accept.
    // const style = document.createElement('style');
    // style.id = STYLESHEET_ID;
    // document.head.appendChild(style);
  }

  disconnectedCallback() {
    this.storeUnsubscribe();
  }

  /*
  private addCSSRule(rules: string) {
    const style = document.getElementById(STYLESHEET_ID);
    if (!style) { return; }
    // @ts-ignore
    (!!style.styleSheet)
      // @ts-ignore
      ? style.styleSheet.cssText = rules
      : style.appendChild(document.createTextNode(rules));
  }

  private removeCSSRules() {
    const style = document.getElementById(STYLESHEET_ID);
    if (!style) { return; }
    // @ts-ignore
    (!!style.styleSheet)
      // @ts-ignore
      ? style.styleSheet.cssText = null
      : style.innerHTML = null;
  } */

  async registerCanvas(el) {
    if (this.sketch) {
      return;
    }
    try {
      this.sketch = await SketchService.connect(
        CobrowseService.common,
        CobrowseService.getMe(),
        el,
        this.room
      );
      this.sketch.resize(window.innerWidth, window.innerHeight);
      this.sketch.scrollTo(window.scrollY, window.scrollX);
    } catch (ex) {
      NotificationService.error("Sketch failed to start", {
        body: ex.message || ex,
        errorCode: ErrorCode.SKETCH_START_FAILED,
      });
      Log.error(ex);
    }
  }

  render() {
    return (
      <Host>
        <canvas
          aria-hidden="true"
          ref={this.registerCanvas.bind(this)}
          data-paper-canvas="sketch"
        ></canvas>
      </Host>
    );
  }
}
